import React from "react";
import ManufacturerContainer from "../containers/Manufacturer/index";

const Manufacturer = () => {
  return (
    <>
      <ManufacturerContainer />
    </>
  );
};

export default Manufacturer;
